export enum UsersViewRenderMode {
    ADVANCED = 'ADVANCED',
    BASIC = 'BASIC'
}
